import React from 'react';
import { MapPin, MessageCircle, Clock, Navigation } from 'lucide-react';
import { businessData } from '../data/mock';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contacto" className="contact section">
      <div className="contact__container container">
        <div className="contact__header">
          <h2 className="section-title">Vení a visitarnos</h2>
          <p className="section-subtitle">
            Te esperamos para compartir buenas cervezas y momentos.
          </p>
        </div>
        
        <div className="contact__grid">
          <div className="contact__info">
            <div className="contact__info-card card">
              <div className="contact__info-item">
                <div className="icon-wrapper">
                  <MapPin size={24} />
                </div>
                <div className="contact__info-content">
                  <h3 className="contact__info-label">Dirección</h3>
                  <p className="contact__info-value">{businessData.address.full}</p>
                </div>
              </div>
              
              <div className="contact__info-item">
                <div className="icon-wrapper">
                  <Clock size={24} />
                </div>
                <div className="contact__info-content">
                  <h3 className="contact__info-label">Horario</h3>
                  <p className="contact__info-value">{businessData.schedule.description}</p>
                </div>
              </div>
              
              <div className="contact__info-item">
                <div className="icon-wrapper icon-wrapper--pink">
                  <MessageCircle size={24} />
                </div>
                <div className="contact__info-content">
                  <h3 className="contact__info-label">WhatsApp</h3>
                  <a 
                    href={`https://wa.me/${businessData.contact.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact__info-value contact__info-link"
                  >
                    {businessData.contact.whatsappDisplay}
                  </a>
                </div>
              </div>
            </div>
            
            <div className="contact__actions">
              <a 
                href={businessData.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary contact__btn"
              >
                <Navigation size={18} />
                Cómo llegar
              </a>
              <a 
                href={`https://wa.me/${businessData.contact.whatsapp}?text=Hola! Quiero hacer una consulta sobre Boulevard Cervecitas`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-pink contact__btn"
              >
                <MessageCircle size={18} />
                Escribinos por WhatsApp
              </a>
            </div>
          </div>
          
          <div className="contact__map">
            <iframe
              title="Ubicación de Boulevard Cervecitas"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3347.8!2d-60.6492!3d-32.9442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7ab116f4a7c1b%3A0x3c7a8c32b8c3f2a8!2sAv.%20Francia%20168%2C%20S2002LSO%20Rosario%2C%20Santa%20Fe%2C%20Argentina!5e0!3m2!1ses!2sar!4v1705500000000!5m2!1ses!2sar"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '16px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
